
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { NumberInput, Size, Button, Category } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';
import { ControlledField } from '../utils';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Number Input`}</h1>
<p>{`Used in forms to set a numerical value to a field. You can also type directly in the input but only positive and negative integers. Any additional props are passed to the input component.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { NumberInput } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<ControlledField initialValue="" style={{ width: 300 }} component={
  <NumberInput placeholder="Number of things" value="" />
} />`} component={NumberInput} mdxType="Playground">
  <ControlledField initialValue="" style={{
        width: 300
      }} component={<NumberInput placeholder="Number of things" value="" mdxType="NumberInput" />} mdxType="ControlledField" />
</Playground>
<p>{`You can also use a custom `}<inlineCode parentName="p">{`renderValue`}</inlineCode>{` function to customize the way the value is displayed`}</p>
<Playground __position={1} __code={`<ControlledField initialValue="" style={{ width: 300 }} component={
  <NumberInput
    renderValue={(v) => v + ' € HTVA'}
    placeholder="Price HTVA"
    value={0}
    onChange={x=>x} />
} />`} mdxType="Playground">
  <ControlledField initialValue="" style={{
        width: 300
      }} component={<NumberInput renderValue={v => v + ' € HTVA'} placeholder="Price HTVA" value={0} onChange={x => x} mdxType="NumberInput" />} mdxType="ControlledField" />
</Playground>
<p>{`You may also disable the counter`}</p>
<Playground __position={2} __code={`<ControlledField initialValue="" style={{ width: 300 }} component={
  <NumberInput
    withCounter={false}
    placeholder="Price of things"
    value="" />
} />`} mdxType="Playground">
  <ControlledField initialValue="" style={{
        width: 300
      }} component={<NumberInput withCounter={false} placeholder="Price of things" value="" mdxType="NumberInput" />} mdxType="ControlledField" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;